export { FaqSearchSection } from './search-section'
